import React from 'react';

const style = {
  container: {
    position: 'fixed',
    bottom: 5,
    zIndex: 5,
    textAlign: 'center',
    color: '#8F685B',
    width: '100vw',
    fontSize: '0.8em',
  },
};

const Footer = props => {
  return (
    <div style={style.container}>
      Product of <a href="http://kennethko.io">Kenneth Ko</a>.
    </div>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js